import { useBreakpoint } from '@eppendorf/vnls-react-components-preview';
import { ReactElement } from 'react';

import { Overview } from '$components/overview-box/overview-box';
import { MonitoringList } from '$features/monitoring/v2/monitoring-list';

export function MonitoringOverview(): ReactElement {
  const isMaxMd = useBreakpoint({ max: 'md' });

  return (
    <Overview className={`box--mobile-fullscreen ${isMaxMd ? 'box--no-shadow' : ''}`}>
      <MonitoringList />
    </Overview>
  );
}
